import { IAtividadeComponenteDAL } from '@medlogic/shared/shared-interfaces';
export interface IControl {
    ctrl: IAtividadeComponenteDAL;
    // lstCadastroAdicional:Array<ICadastro>;
    // getValorDaListaCadastroAdicional(index:string, variavelCadastroAdicional:string);
}
